import {SERVICE_INPROGRESS } from "../loader/LoaderAction";

const initialState = {
   isLoading: false,
 };
 const Loader = (state = initialState, action) => {
    console.log(action.type,`triggerred`)
    switch (action.type) {
       case SERVICE_INPROGRESS:
          return Object.assign({}, state, {
            isLoading: action.value
          })
       default:
          return state;
    }
 }
 export default Loader;